import client from '../client'

export async function requestUserEmailConfirmation({ email, password }) {
  return client(
    `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/requestuseremailconfirmation`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ email, password }),
    },
  )
}
